import { Allergen, Dog, Meal, NewFlavour } from '@/gql/graphql'

const getAllergenSlugs = (dogs: Dog[]): string[] =>
  dogs.flatMap((dog: Dog) =>
    dog.allergens.flatMap((allergen: Allergen) =>
      allergen.flavours.map((flavour: NewFlavour) => flavour.slug)
    )
  )

const sortAndFilterRecipes = (recipes: Meal[], dogs: Dog[]): Meal[] => {
  const allergenSlugs = getAllergenSlugs(dogs)

  return recipes
    ?.filter((freshMeal: Meal) => freshMeal.quantity > 0)
    ?.sort((a: Meal, b: Meal) => {
      return (
        (allergenSlugs?.includes(a.flavour.slug) ? 1 : 0) -
        (allergenSlugs?.includes(b.flavour.slug) ? 1 : 0)
      )
    })
}

export { getAllergenSlugs, sortAndFilterRecipes }
